export default "__VITE_ASSET__BigrVuvl__"